import { Advertisement } from "@adgate/common/types/advertisement.type";
import { BaseObject } from "@adgate/common/types/base-object.type";
import { Category } from "@adgate/common/types/category.type";
import { ChannelFamily } from "@adgate/common/types/channel-family.type";

export class Commercial extends Advertisement
{
    public static OBJECT_TYPE:number                      = 1;

    product!: string;
    version!: string;
    category!: Category;
    durationEstimated!: number;
    durationReal!: number | null;
    crt!: string | null;
    channelFamilies!: ChannelFamily[];
    attributes!: BaseObject[];

    constructor()
    {
        super();
        this.attributes = [];
        this.channelFamilies = [];
    }
}